var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import chroma from "chroma-js";
export function alpha(color, value) {
    if (value === void 0) { value = .5; }
    return chroma(color).alpha(value).hex();
}
export var RGBAToHexA = function (props) {
    var r = props.r.toString(16);
    var g = props.g.toString(16);
    var b = props.b.toString(16);
    var a = Math.round(props.a * 255).toString(16);
    if (r.length === 1)
        r = '0' + r;
    if (g.length === 1)
        g = '0' + g;
    if (b.length === 1)
        b = '0' + b;
    if (a.length === 1)
        a = '0' + a;
    return '#' + r + g + b + a;
};
export function contrast(color, value, transparency) {
    if (value === void 0) { value = .4; }
    if (transparency === void 0) { transparency = .25; }
    return chroma(color).luminance() <= value
        ? chroma('#fff').alpha(transparency).hex()
        : chroma('000').alpha(transparency).hex();
}
export function luminance(color, value, darken, brighten) {
    if (value === void 0) { value = .35; }
    if (darken === void 0) { darken = .5; }
    if (brighten === void 0) { brighten = .5; }
    return chroma(color).luminance() <= value
        ? chroma(color).brighten(brighten).hex()
        : chroma(color).darken(darken).hex();
}
export function reverseLuminance(color, value, darken, brighten) {
    if (value === void 0) { value = .35; }
    if (darken === void 0) { darken = .5; }
    if (brighten === void 0) { brighten = .5; }
    return chroma(color).luminance() >= value
        ? chroma(color).brighten(brighten).hex()
        : chroma(color).darken(darken).hex();
}
export function luminanceWithSaturate(color, value, darken, brighten) {
    if (value === void 0) { value = .35; }
    if (darken === void 0) { darken = 4; }
    if (brighten === void 0) { brighten = 3; }
    return chroma(color).luminance() <= value
        ? chroma(color).brighten(brighten).desaturate().hex()
        : chroma(color).darken(darken).hex();
}
export function setColor(backgroundColor, color) {
    return {
        backgroundColor: backgroundColor,
        color: color || luminanceWithSaturate(backgroundColor)
    };
}
export var camelize = function (str) {
    str = str.toLowerCase().replace(/(?:(^.)|([-_\s]+.))/g, function (match) {
        return match.charAt(match.length - 1).toUpperCase();
    });
    return str.charAt(0).toLowerCase() + str.substring(1);
};
export var decamelize = function (str, separator) {
    if (separator === void 0) { separator = " "; }
    return str
        .replace(/([a-z\d])([A-Z])/g, "$1" + separator + "$2")
        .replace(/([A-Z]+)([A-Z][a-z\d]+)/g, "$1" + separator + "$2")
        .toLowerCase();
};
export var urlToBlob = function (url) { return __awaiter(void 0, void 0, void 0, function () {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, new Promise(function (resolve, reject) {
                    var xhr = new XMLHttpRequest();
                    xhr.onerror = reject;
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState === 4) {
                            resolve(xhr.response);
                        }
                    };
                    xhr.open('GET', url);
                    xhr.responseType = 'blob';
                    xhr.send();
                })];
            case 1: return [2, _a.sent()];
        }
    });
}); };
